import SignupForm from './SignupForm.component';

export default SignupForm;
